import {FACTION_CONFIGS, RANDOM_FACTION_CONFIG, RANDOM_FACTION_ID} from '../../../configs/factions';
import {getFactionSkinDisplayProps} from '../../../utils/factions/getFactionSkinDisplayProps';
import {getFactionImagePath} from '../../../utils/factions/getFactionImagePath';
import {getFactionIconPath} from '../../../utils/factions/getFactionIconPath';
import {getFactionSkinRank} from '../../../utils/factions/getFactionSkinRank';
import {getRankSkinFrameByRank} from '../../../utils/factions/getRankSkinFramePath';

/**
 * Как показать фракцию в десктопном лобби: полный арт со скином игрока, имя,
 * цвет фракции (скина), рамка рейтингового образа и шевроны обычного
 * обличья — то же, что в карусели выбора фракции (FactionSelectPage).
 * «Случайная фракция» — без скинов, с картинкой и цветом из своего конфига.
 *
 * @param {string} factionId
 * @param {string} [skinId] - выбранный скин игрока для этой фракции
 * frameBackgroundColor — фон цвета лиги под арт рейтингового образа в рамке
 * (тот же, что в карусели скинов: imageContainerStyle рейтингового образа).
 * iconPath — иконка того же образа (лицо 256×256) для компактной сетки; у
 * «Случайной» иконки нет — там тот же бюст.
 *
 * @returns {{factionId: string, name: string, imagePath: string, iconPath: string, textColor: string,
 *   skinName: (string|null), framePath: (string|null), frameBackgroundColor: (string|null),
 *   skinRank: (number|null)}|null}
 */
export const getLobbyFactionDisplay = (factionId, skinId) => {
  if (!factionId) {
    return null;
  }
  if (factionId === RANDOM_FACTION_ID) {
    return {
      factionId,
      name: RANDOM_FACTION_CONFIG.name,
      imagePath: RANDOM_FACTION_CONFIG.imagePath,
      iconPath: RANDOM_FACTION_CONFIG.imagePath,
      textColor: RANDOM_FACTION_CONFIG.textColor,
      skinName: null,
      framePath: null,
      frameBackgroundColor: null,
      skinRank: null,
    };
  }
  const faction = FACTION_CONFIGS.find((config) => config.id === factionId);
  if (!faction) {
    return null;
  }
  const displayProps = getFactionSkinDisplayProps(faction, skinId);
  return {
    factionId,
    name: faction.name,
    imagePath: displayProps.imagePath || getFactionImagePath(factionId),
    iconPath: displayProps.iconPath || getFactionIconPath(factionId),
    textColor: displayProps.textColor || faction.textColor,
    skinName: displayProps.skinName || null,
    framePath: getRankSkinFrameByRank(displayProps.rank),
    frameBackgroundColor: displayProps.rank ? displayProps.imageContainerStyle?.backgroundColor || null : null,
    skinRank: getFactionSkinRank(skinId, factionId),
  };
};
